import { Source, Layer } from "react-map-gl/mapbox"

export const TerrainLayer = () => {
  return (
    <>
      <Source
        id="mapbox-dem"
        type="raster-dem"
        url="mapbox://mapbox.mapbox-terrain-dem-v1"
        tileSize={512}
        maxzoom={14}
      />
      <Layer id="terrain" type="hillshade" source="mapbox-dem" paint={{ "hillshade-exaggeration": 0.5 }} />
    </>
  )
}
